



















































const R = require("ramda");
import Vue from "vue";

export default Vue.extend<any, any, any, any>({
  name: "ProductDetail",
  props: {},

  data: function () {
    return {
      modalOpen: false,
      waiting: 0,
    };
  },
  methods: {
    addClickHandlers: function () {
      let querySelector = ".shop_fe-add-to-cart";
      const elements: HTMLElement[] = Array.from(
        document.querySelectorAll(querySelector)
      );
      elements.forEach((element) => {
        const sku = element.dataset.sku;
        element.addEventListener("click", () => {
          this.addToCart(sku);
        });
      });
    },
    addToCart: function (sku: String) {
      this.waiting++;
      this.$store
        .dispatch("addToCart", sku)
        .then((res) => {
          this.waiting--;
          console.log("#log 9376", res);
          this.modalOpen = true;
        })
        .catch((res) => {
          console.error(res);
          // handleErrorsFromResponse(this, res);
          this.waiting--;
        });
    },
  },
  computed: {},
  mounted: function () {
    this.addClickHandlers();
  },
});
